<template>
	<div class="min-h-screen bg-gray-50">

		<!-- css样式库 -->
		<link href="https://cdn.jsdelivr.net/npm/tailwindcss@2.2.19/dist/tailwind.min.css" rel="stylesheet">
		<!-- 图标库 -->
		<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css">

		<!-- 注意事项 -->
		<div class="bg-yellow-50 border-l-4 border-yellow-400 p-4">
			<div class="flex">
				<div class="flex-shrink-0">
					<i class="fas fa-exclamation-triangle text-yellow-400"></i>
				</div>
				<div class="ml-3">
					<h3 class="text-sm font-medium text-yellow-800">
						<!-- 注意事项 -->
						{{ $t('language000209') }}
					</h3>
					<p class="mt-2 text-sm text-yellow-700">
						<!-- 将请求的参数转换为JSON，将JSON用AES加密后放在请求的请求体中，然后发送给API服务端请求数据 -->
						{{ $t('language000227') }}
					</p>
				</div>
			</div>
		</div>

		<main class="mx-auto px-4 py-8">
			<!-- 加密过程展示 -->
			<section class="mb-12">
				<div class="flex items-center gap-2 mb-6">
					<h2 class="text-xl font-semibold">
						<!-- 加密过程 -->
						{{ $t('language000228') }}
					</h2>
					<span class="px-2 py-0.5 text-xs bg-gray-100 text-gray-400 rounded mt-2">
						<!-- 测试环境 -->
						{{ $t('language000178') }}
					</span>
				</div>
				<div class="bg-white rounded-lg shadow-md p-6">
					<div class="grid grid-cols-1 gap-6">
						<!-- 原始数据 -->
						<div class="bg-gray-50 p-4 rounded-lg">
							<label class="block text-sm font-medium text-gray-700  mb-2">
								<!-- 原始数据 -->
								{{ $t('language000229') }}
							</label>
							<div class="flex items-center">
								<input type="text" v-model="originalData"
									class="flex-1 border border-gray-200  rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm p-2"
									:placeholder="$t('language000230')">
								<button @click="handleEncrypt"
									class="ml-4 bg-blue-600 text-white px-4 py-2 !rounded-button whitespace-nowrap hover:bg-blue-700">
									<!-- 执行加密 -->
									{{ $t('language000231') }}
								</button>
							</div>
						</div>

						<!-- 加密参数展示 -->
						<div class="bg-gray-50 p-4 rounded-lg">
							<h3 class="font-medium mb-4">
								<!-- 加密参数 -->
								{{ $t('language000232') }}
							</h3>
							<div class="space-y-3">
								<div class="flex items-start">
									<span class="text-sm font-medium text-gray-500">
										<!-- 加密密钥： -->
										{{ $t('language000233') }}：
									</span>
									<span class="text-sm text-gray-700">{{ encryptionKey }}</span>
								</div>
								<div class="flex items-start">
									<span class="text-sm font-medium text-gray-500 ">
										<!-- IV 向量： -->
										{{ $t('language000234') }}：
									</span>
									<span class="text-sm text-gray-700">{{ iv }}</span>
								</div>
								<div class="flex items-start">
									<span class="text-sm font-medium text-gray-500 ">
										<!-- 加密模式： -->
										{{ $t('language000235') }}：
									</span>
									<span class="text-sm text-gray-700">CBC</span>
								</div>
								<div class="flex items-start">
									<span class="text-sm font-medium text-gray-500">
										<!-- 填充方式： -->
										{{ $t('language000236') }}：
									</span>
									<span class="text-sm text-gray-700">PKCS7</span>
								</div>
							</div>
						</div>

						<!-- 加密结果 -->
						<div class="bg-gray-50 p-4 rounded-lg">
							<h3 class="block text-sm font-medium text-gray-700 mb-2">
								<!-- 加密结果 -->
								{{ $t('language000237') }}
							</h3>
							<div class="bg-white p-3 rounded border border-gray-200">
								<p class="text-sm text-gray-600 break-all">{{ encryptedResult }}</p>
							</div>
						</div>
					</div>
				</div>
			</section>

			<!-- 解密过程展示 -->
			<section class="mb-12">
				<div class="flex items-center gap-2 mb-6">
					<h2 class="text-xl font-semibold">
						<!-- 解密过程 -->
						{{ $t('language000238') }}
					</h2>
					<span class="px-2 py-0.5 text-xs bg-gray-100 text-gray-400 rounded mt-2">
						<!-- 测试环境 -->
						{{ $t('language000178') }}
					</span>
				</div>
				<div class="bg-white rounded-lg shadow-md p-6">
					<div class="grid grid-cols-1 gap-6">
						<!-- 加密数据 -->
						<div class="bg-gray-50 p-4 rounded-lg">
							<label class="block text-sm font-medium text-gray-700 mb-2">
								<!-- 加密数据 -->
								{{ $t('language000239') }}
							</label>
							<div class="flex items-center">
								<input type="text" v-model="encryptedData"
									class="flex-1 border border-gray-200 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm p-2"
									:placeholder="$t('language000240')">
								<button @click="handleDecrypt"
									class="ml-4 bg-green-600 text-white px-4 py-2 !rounded-button whitespace-nowrap hover:bg-green-700">
									<!-- 执行解密 -->
									{{ $t('language000241') }}
								</button>
							</div>
						</div>

						<!-- 解密参数展示 -->
						<div class="bg-gray-50 p-4 rounded-lg">
							<h3 class="font-medium mb-4">
								<!-- 解密参数 -->
								{{ $t('language000242') }}
							</h3>
							<div class="space-y-3">
								<div class="flex items-start">
									<span class="text-sm font-medium text-gray-500 ">
										<!-- 解密密钥： -->
										{{ $t('language000243') }}：
									</span>
									<span class="text-sm text-gray-700">{{ encryptionKey }}</span>
								</div>
								<div class="flex items-start">
									<span class="text-sm font-medium text-gray-500 ">
										<!-- IV 向量： -->
										{{ $t('language000234') }}：
									</span>
									<span class="text-sm text-gray-700">{{ iv }}</span>
								</div>
								<div class="flex items-start">
									<span class="text-sm font-medium text-gray-500">
										<!-- 解密模式： -->
										{{ $t('language000244') }}：
									</span>
									<span class="text-sm text-gray-700">CBC</span>
								</div>
								<div class="flex items-start">
									<span class="text-sm font-medium text-gray-500">
										<!-- 填充方式： -->
										{{ $t('language000236') }}：
									</span>
									<span class="text-sm text-gray-700">PKCS7</span>
								</div>
							</div>
						</div>

						<!-- 解密结果 -->
						<div class="bg-gray-50 p-4 rounded-lg">
							<h3 class="block text-sm font-medium text-gray-700 mb-2">
								<!-- 解密结果 -->
								{{ $t('language000245') }}
							</h3>
							<div class="bg-white p-3 rounded border border-gray-200">
								<p class="text-sm text-gray-600 break-all">{{ decryptedResult }}</p>
							</div>
						</div>
					</div>
				</div>
			</section>

			<!-- 更新密钥 -->
			<section class="mb-12">
				<div class="flex items-center gap-2 mb-6">
					<h2 class="text-xl font-semibold">
						<!-- 更新密钥 -->
						{{ $t('language000246') }}
					</h2>
					<span class="px-2 py-0.5 text-xs bg-gray-100 text-gray-400 rounded mt-2">
						<!-- 测试环境 -->
						{{ $t('language000178') }}
					</span>
				</div>
				<div class="bg-white rounded-lg shadow-md p-6">
					<div class="flex items-center gap-3">
						<div class="relative flex-1">
							<input type="text" v-model="newEncryptionKey" :placeholder="$t('language000247')"
								class="w-full text-sm border border-gray-300 rounded-md px-3 py-2.5 pr-10 focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none" />
							<span v-if="newEncryptionKey" @click="newEncryptionKey = ''"
								class="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 cursor-pointer">
								<i class="fas fa-times-circle"></i>
							</span>
						</div>
						<button @click="updateEncryptionKey"
							class="!rounded-button whitespace-nowrap bg-blue-600 text-white text-sm font-medium px-5 py-2.5 hover:bg-blue-700 transition-colors disabled:bg-blue-300 disabled:cursor-not-allowed"
							:disabled="!newEncryptionKey">
							<!-- 设置新密钥 -->
							{{ $t('language000248') }}
						</button>
					</div>

					<!-- 提示信息 -->
					<div class="mt-3 flex items-start gap-2">
						<i class="fas fa-info-circle text-blue-500 mt-0.5"></i>
						<p class="text-sm text-gray-500">
							<!-- AES 支持三种密钥长度：128 位、192 位和 256 位。请确保输入的密钥长度符合要求，建议使用强密码生成器生成密钥以提高安全性。 -->
							{{ $t('language000249') }}
						</p>
					</div>
				</div>
			</section>

			<!-- 注意事项 -->
			<div class="bg-yellow-50 border-l-4 border-yellow-400 p-4" style="margin-top: 30px;">
				<div class="flex">
					<div class="flex-shrink-0">
						<i class="fas fa-exclamation-triangle text-yellow-400"></i>
					</div>
					<div class="ml-3">
						<h3 class="text-sm font-medium text-yellow-800">
							<!-- 注意事项 -->
							{{ $t('language000209') }}
						</h3>
						<p class="mt-2 text-sm text-yellow-700">
							<!-- 具体加解密如遇到问题，可联系我们！ -->
							{{ $t('language000250') }}
						</p>
					</div>
				</div>
			</div>

		</main>


		<div>
			<div class="mx-auto px-4 py-8">
				<div class="mx-auto">
					<h1 class="text-4xl font-bold text-center mb-12 text-blue-600">
						<!-- 加密解密代码示例 -->
						{{ $t('language000251') }}
					</h1>

					<!-- Language Tabs -->
					<div class="flex space-x-2 mb-6">
						<button v-for="lang in languages" :key="lang.id" @click="currentLanguage = lang.id"
							:class="[ '!rounded-button whitespace-nowrap px-6 py-2.5 font-medium transition-colors', currentLanguage === lang.id ? 'bg-blue-600 text-white'  : 'bg-white text-gray-700 hover:bg-gray-100' ]">
							{{ lang.name }}
						</button>
					</div>

					<!-- Code Display -->
					<div class="bg-white rounded-lg shadow-lg overflow-hidden">
						<div class="flex items-center justify-between px-6 py-3 bg-gray-800">
							<div class="flex items-center space-x-2">
								<div class="w-3 h-3 rounded-full bg-red-500"></div>
								<div class="w-3 h-3 rounded-full bg-yellow-500"></div>
								<div class="w-3 h-3 rounded-full bg-green-500"></div>
							</div>
							<span class="text-gray-400 text-sm">{{ getCurrentLanguage.name }}
								<!-- 示例代码 -->
								{{ $t('language000252') }}
							</span>
						</div>

						<div class="p-6 bg-gray-900">
							<pre
								class="text-gray-100 font-mono text-sm leading-relaxed whitespace-pre-wrap">{{ getCurrentLanguage.code }}
							</pre>
						</div>
					</div>

					<!-- Description -->
					<div class="mt-8 bg-white rounded-lg p-6 shadow-lg">
						<h2 class="text-xl font-semibold mb-4">
							<!-- 代码说明 -->
							{{ $t('language000253') }}
						</h2>
						<p class="text-gray-600 leading-relaxed">{{ getCurrentLanguage.description }}</p>
					</div>

					<!-- Key Features -->
					<div class="mt-8 grid grid-cols-3 gap-6">
						<div v-for="(feature, index) in features" :key="index"
							class="bg-white p-6 rounded-lg shadow-lg">
							<div class="text-blue-600 mb-4">
								<i :class="feature.icon" class="text-2xl"></i>
							</div>
							<h3 class="text-lg font-semibold mb-2">{{ feature.title }}</h3>
							<p class="text-gray-600">{{ feature.description }}</p>
						</div>
					</div>
				</div>
			</div>
		</div>


	</div>
</template>

<script>
	import CryptoJS from 'crypto-js';

	export default {
		data() {
			return {
				originalData: '', //需要加密的内容
				encryptedData: '', //需要解密的内容
				encryptedResult: '', //加密结果
				decryptedResult: '', //解密结果
				encryptionKey: '1234567891011121', //密钥  可以使用 16 字节（128 位）密钥还有其他的...
				newEncryptionKey: '', // 用于输入新的密钥
				iv: '0123456789abcdef',
				currentLanguage: 'java',
				languages: [{
						id: 'java',
						name: 'Java',
						code: `public class AESUtil {
				    private static final String KEY_ALGORITHM = "AES";
				    private static final String DEFAULT_CIPHER_ALGORITHM = "AES/CBC/PKCS5Padding";
				
				    public static String encrypt(String content, String key, String iv) throws Exception {
				        Cipher cipher = Cipher.getInstance(DEFAULT_CIPHER_ALGORITHM);
				        byte[] byteContent = content.getBytes("utf-8");
				        IvParameterSpec ivParameterSpec = new IvParameterSpec(iv.getBytes());
				        SecretKeySpec keySpec = new SecretKeySpec(key.getBytes(), KEY_ALGORITHM);
				        cipher.init(Cipher.ENCRYPT_MODE, keySpec, ivParameterSpec);
				        byte[] result = cipher.doFinal(byteContent);
				        return Base64.getEncoder().encodeToString(result);
				    }
				
				    public static String decrypt(String content, String key, String iv) throws Exception {
				        Cipher cipher = Cipher.getInstance(DEFAULT_CIPHER_ALGORITHM);
				        IvParameterSpec ivParameterSpec = new IvParameterSpec(iv.getBytes());
				        SecretKeySpec keySpec = new SecretKeySpec(key.getBytes(), KEY_ALGORITHM);
				        cipher.init(Cipher.DECRYPT_MODE, keySpec, ivParameterSpec);
				        byte[] result = cipher.doFinal(Base64.getDecoder().decode(content));
				        return new String(result, "utf-8");
				    }
				}`,
						description: this.$t('language000254')
					},
					{
						id: 'kotlin',
						name: 'Kotlin',
						code: `object AESUtil {
				    private const val KEY_ALGORITHM = "AES"
				    private const val DEFAULT_CIPHER_ALGORITHM = "AES/CBC/PKCS5Padding"
				
				    fun encrypt(content: String, key: String, iv: String): String {
				        val cipher = Cipher.getInstance(DEFAULT_CIPHER_ALGORITHM)
				        val byteContent = content.toByteArray(charset("utf-8"))
				        val ivParameterSpec = IvParameterSpec(iv.toByteArray())
				        val keySpec = SecretKeySpec(key.toByteArray(), KEY_ALGORITHM)
				        cipher.init(Cipher.ENCRYPT_MODE, keySpec, ivParameterSpec)
				        val result = cipher.doFinal(byteContent)
				        return Base64.getEncoder().encodeToString(result)
				    }
				
				    fun decrypt(content: String, key: String, iv: String): String {
				        val cipher = Cipher.getInstance(DEFAULT_CIPHER_ALGORITHM)
				        val ivParameterSpec = IvParameterSpec(iv.toByteArray())
				        val keySpec = SecretKeySpec(key.toByteArray(), KEY_ALGORITHM)
				        cipher.init(Cipher.DECRYPT_MODE, keySpec, ivParameterSpec)
				        val result = cipher.doFinal(Base64.getDecoder().decode(content))
				        return String(result, charset("utf-8"))
				    }
				}`,
						description: this.$t('language000276')
					},
					{
						id: 'vue2',
						name: 'Vue2',
						code: `import CryptoJS from 'crypto-js'
				
				export default {
				  data() {
				    return {
				      encryptionKey: '',
				      iv: '',
				      originalData: '',
				      encryptedResult: '',
				      decryptedResult: ''
				    }
				  },
				  methods: {
				    handleEncrypt() {
				      if (!this.originalData) {
				        this.encryptedResult = ''
				        return
				      }
				      const key = CryptoJS.enc.Utf8.parse(this.encryptionKey)
				      const iv = CryptoJS.enc.Utf8.parse(this.iv)
				      const encrypted = CryptoJS.AES.encrypt(this.originalData, key, {
				        iv: iv,
				        mode: CryptoJS.mode.CBC,
				        padding: CryptoJS.pad.Pkcs7
				      })
				      this.encryptedResult = encrypted.toString()
				    },
				    handleDecrypt() {
				      if (!this.encryptedData) {
				        this.decryptedResult = ''
				        return
				      }
				      const key = CryptoJS.enc.Utf8.parse(this.encryptionKey)
				      const iv = CryptoJS.enc.Utf8.parse(this.iv)
				      const decrypted = CryptoJS.AES.decrypt(this.encryptedData, key, {
				        iv: iv,
				        mode: CryptoJS.mode.CBC,
				        padding: CryptoJS.pad.Pkcs7
				      })
				      this.decryptedResult = decrypted.toString(CryptoJS.enc.Utf8)
				    }
				  }
				}`,
						description: this.$t('language000277')
					},
					{
						id: 'swift',
						name: 'Swift',
						code: `import Foundation
				import CommonCrypto
				
				class AESUtil {
				    static func encrypt(string: String, key: String, iv: String) -> String? {
				        guard let data = string.data(using: .utf8),
				              let keyData = key.data(using: .utf8),
				              let ivData = iv.data(using: .utf8) else { return nil }
				        
				        let cryptLength = size_t(Int(ceil(Double(data.count) / Double(kCCBlockSizeAES128))) * kCCBlockSizeAES128)
				        var cryptData = Data(count: cryptLength)
				        
				        let keyLength = size_t(kCCKeySizeAES128)
				        let options = CCOptions(kCCOptionPKCS7Padding)
				        var numBytesEncrypted: size_t = 0
				        
				        let cryptStatus = cryptData.withUnsafeMutableBytes { cryptBytes in
				            data.withUnsafeBytes { dataBytes in
				                keyData.withUnsafeBytes { keyBytes in
				                    ivData.withUnsafeBytes { ivBytes in
				                        CCCrypt(CCOperation(kCCEncrypt),
				                                CCAlgorithm(kCCAlgorithmAES),
				                                options,
				                                keyBytes.baseAddress, keyLength,
				                                ivBytes.baseAddress,
				                                dataBytes.baseAddress, data.count,
				                                cryptBytes.baseAddress, cryptLength,
				                                &numBytesEncrypted)
				                    }
				                }
				            }
				        }
				        
				        if cryptStatus == kCCSuccess {
				            cryptData.removeSubrange(numBytesEncrypted..<cryptData.count)
				            let base64String = cryptData.base64EncodedString()
				            return base64String
				        }
				        
				        return nil
				    }
				    
				    static func decrypt(string: String, key: String, iv: String) -> String? {
				        guard let data = Data(base64Encoded: string),
				              let keyData = key.data(using: .utf8),
				              let ivData = iv.data(using: .utf8) else { return nil }
				        
				        let cryptLength = size_t(Int(ceil(Double(data.count) / Double(kCCBlockSizeAES128))) * kCCBlockSizeAES128)
				        var cryptData = Data(count: cryptLength)
				        
				        let keyLength = size_t(kCCKeySizeAES128)
				        let options = CCOptions(kCCOptionPKCS7Padding)
				        var numBytesDecrypted: size_t = 0
				        
				        let cryptStatus = cryptData.withUnsafeMutableBytes { cryptBytes in
				            data.withUnsafeBytes { dataBytes in
				                keyData.withUnsafeBytes { keyBytes in
				                    ivData.withUnsafeBytes { ivBytes in
				                        CCCrypt(CCOperation(kCCDecrypt),
				                                CCAlgorithm(kCCAlgorithmAES),
				                                options,
				                                keyBytes.baseAddress, keyLength,
				                                ivBytes.baseAddress,
				                                dataBytes.baseAddress, data.count,
				                                cryptBytes.baseAddress, cryptLength,
				                                &numBytesDecrypted)
				                    }
				                }
				            }
				        }
				        
				        if cryptStatus == kCCSuccess {
				            cryptData.removeSubrange(numBytesDecrypted..<cryptData.count)
				            let decryptedString = String(data: cryptData, encoding: .utf8)
				            return decryptedString
				        }
				        
				        return nil
				    }
				}`,
						description: this.$t('language000278')
					}
				],
				//...
			};
		},
		computed: {
			features() {
				return [{
						icon: 'fas fa-shield-alt',
						title: this.$t('language000255'), //安全性
						description: this.$t('language000256'), //使用业界标准的 AES 加密算法，确保数据传输和存储的安全性。
					},
					{
						icon: 'fas fa-sync',
						title: this.$t('language000257'), //兼容性
						description: this.$t('language000258'), //支持多种编程语言，确保在不同平台之间的数据加解密兼容。
					},
					{
						icon: 'fas fa-code',
						title: this.$t('language000259'), //易用性
						description: this.$t('language000260'), //提供简单清晰的 API，方便开发者快速集成和使用。
					}
				]
			},
			getCurrentLanguage() {
				return this.languages.find(lang => lang.id === this.currentLanguage) || this.languages[0];
			}
		},
		methods: {
			handleEncrypt() {
				if (!this.originalData) {
					this.encryptedResult = "";
					return;
				}
				// 使用 AES 加密
				const key = CryptoJS.enc.Utf8.parse(this.encryptionKey);
				const iv = CryptoJS.enc.Utf8.parse(this.iv);
				const encrypted = CryptoJS.AES.encrypt(this.originalData, key, {
					iv: iv,
					mode: CryptoJS.mode.CBC,
					padding: CryptoJS.pad.Pkcs7
				});
				// 将加密结果转换为 Base64 字符串
				this.encryptedResult = encrypted.toString();
			},
			handleDecrypt() {
				if (!this.encryptedData) {
					this.decryptedResult = "";
					return;
				}
				// 使用 AES 解密，不使用 IV
				const key = CryptoJS.enc.Utf8.parse(this.encryptionKey);
				const iv = CryptoJS.enc.Utf8.parse(this.iv);
				const decrypted = CryptoJS.AES.decrypt(this.encryptedData, key, {
					iv: iv,
					mode: CryptoJS.mode.CBC, // 使用 ECB 模式
					padding: CryptoJS.pad.Pkcs7
				});
				// 将解密结果转换为 UTF-8 字符串
				this.decryptedResult = decrypted.toString(CryptoJS.enc.Utf8);
			},
			updateEncryptionKey() {
				this.encryptionKey = this.newEncryptionKey; // 更新加密密钥
			},
			//...
		}
	};
</script>

<style scoped>
	.container {
		max-width: 1440px;
	}
</style>